import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router, UrlTree } from '@angular/router';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { Apollo } from 'apollo-angular';
import { LandingService } from 'src/app/service/landing.service';
import { SharedService } from 'src/app/service/shared.service';
import { isPlatformBrowser } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'trpx-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent implements OnInit {
  headerData: any;
  componentName: string = 'LandingComponent';
  landingCardsList: any;
  landingCardsGrid: any;
  pageName: any;
  firstLoading: boolean = true;
  dataNull: any;
  pageNameHeading: any;
  loaderGif: boolean = false;
  indigoLabel: boolean = false;
  yesrewardLabel: boolean = false;
  hostUrl: any;
  baseUrl: any;
  appTitle: string = 'tripXOXO - Activities, tours and transfers';
  appDescription: string =
    'Tripxoxo is a digital platform for travelers to book their activities, experiences, tickets, sightseeing tours, and everything that they would need once they reach the destination.';

  isWhiteLabelActive: boolean = false;
  isLoading: boolean = false;
  isOndc: boolean = false;
  searchId: any;
  cityCode: any;

  constructor(
    private http: HttpClient,
    private apollo: Apollo,
    public landService: LandingService,
    private route: ActivatedRoute,
    public router: Router,
    private sharedService: SharedService,
    private locationStrategy: LocationStrategy,
    private meta: Meta,
    private titleService: Title,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.pageName = this.route.snapshot.params['id'];
      this.isWhiteLabelActive = !!localStorage.getItem('white_label_source');
    }
  }
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.pageName = this.route.snapshot.params['id'];
      let baseUrl = window.location.origin;
      if (baseUrl?.includes('indigo')) {
        this.loaderGif = true;
        this.indigoLabel = true;
      } else if (baseUrl?.includes('yesrewards')) {
        this.loaderGif = true;
        this.yesrewardLabel = true;
      }

      let whiteLabelFromStorage = !!localStorage.getItem('white_label_source');

      this.sharedService.whiteLabelStatus$.subscribe((status) => {
        this.isWhiteLabelActive = status || whiteLabelFromStorage;
        if (this.pageName && this.isWhiteLabelActive) {
          this.getLandingDetails();
        }
      });

      // Initial call to get details if applicable
      // if (this.pageName && this.isWhiteLabelActive) {
      //   this.getLandingDetails();
      // }

      this.sharedService.setShowHeader(false);
      this.updateMetaTags(this.appTitle, this.appDescription);
    }
  }

  getLandingDetails() {
    this.apollo
      .watchQuery({
        query: this.landService.landingPage,
        variables: {
          landingSlug: this.pageName,
          fields: [
            'id',
            'name',
            'price',
            'tag',
            'product_slug',
            'product_description_set',
            'product_banners',
            'product_icons',
            'vendor__slug',
            'slashed_price',
          ],
        },
      })
      .valueChanges.subscribe(({ data, error }: any) => {
        let result = data?.landingPage?.page_type;
        this.isOndc = data?.landingPage?.is_ondc;
        this.searchId = data?.landingPage?.search_id;
        if (data?.landingPage?.is_ondc) {
          this.isLoading = true;
          let requestData = {
            slug: this.pageName,
            search_id: data?.landingPage?.search_id,
          };

          if (result === 'GRID-LANDING-PAGE' || result === 'LIST-LANDING-PAGE') {
            const fetchProducts = (attempts: number) => {
              if (attempts >= 20) { // Stop after 20 attempts
                this.firstLoading = false;
                this.isLoading = false;
                return;
              }
          
              this.landService.setONDCProduct(requestData).subscribe((res) => {
                if (res?.city_code) {
                  this.cityCode = res.city_code;
                }
                const newProducts = res?.PRODUCTS || [];
          
                if (result === 'GRID-LANDING-PAGE') {
                  this.landingCardsGrid = [...(this.landingCardsGrid || []), ...newProducts]; // Append data
                } else {
                  this.landingCardsList = [...(this.landingCardsList || []), ...newProducts]; // Append data
                }
          
                setTimeout(() => fetchProducts(attempts + 1), 1000); // Retry after 1 sec
              });
            };
          
            this.firstLoading = true;
            fetchProducts(0); // Start with 0 attempts
          }
         

          // if (result === 'GRID-LANDING-PAGE') {
          //   const fetchProducts = (attempts: number) => {
          //     this.landService.setONDCProduct(requestData).subscribe((res) => {
          //       this.landingCardsGrid = res?.PRODUCTS;

          //       if (
          //         (!this.landingCardsGrid ||
          //           this.landingCardsGrid.length === 0) &&
          //         attempts < 10
          //       ) {
          //         fetchProducts(attempts + 1); // Retry
          //       } else {
          //         this.firstLoading = false; // Stop loading after successful fetch or max retries
          //         this.isLoading = false;
          //       }
          //     });
          //   };

          //   this.firstLoading = true;
          //   fetchProducts(0); // Start with 0 attempts
          // }
          // if (result === 'LIST-LANDING-PAGE') {
          //   const fetchProducts = (attempts: number) => {
          //     this.landService.setONDCProduct(requestData).subscribe((res) => {
          //       this.landingCardsList = res?.PRODUCTS;
          
          //       if ((!this.landingCardsList || this.landingCardsList.length === 0) && attempts < 10) {
          //         fetchProducts(attempts + 1); // Retry if the list is null, undefined, or empty
          //       } else {
          //         this.firstLoading = false; // Stop loading after successful fetch or max retries
          //         this.isLoading = false;
          //       }
          //     });
          //   };
          
          //   this.firstLoading = true;
          //   fetchProducts(0); // Start with 0 attempts
          // }
        }

        this.dataNull = data?.landingPage;
        if (this.dataNull && this.dataNull.length === 0) {
          this.router.navigate(['/']);
        }
        this.headerData = data?.landingPage?.HEADER;
        if (result == 'GRID-LANDING-PAGE') {
          this.landingCardsGrid = data?.landingPage?.PRODUCTS;
          this.firstLoading = false;
        }
        if (result == 'LIST-LANDING-PAGE') {
          this.landingCardsList = data?.landingPage?.PRODUCTS;
          this.firstLoading = false;
        }
        this.pageNameHeading = this.headerData?.subheading2;
      });
  }

  openLink(productSlug: string) {
    if (!productSlug) {
      console.error("Invalid productSlug:", productSlug);
      return "#"; // Prevent broken links
    }
  
    if (isPlatformBrowser(this.platformId)) {
      let urlTree: UrlTree;
  
      if (this.isOndc) {
        urlTree = this.router.createUrlTree(
          [`/ondc-product/${productSlug}`], 
          { queryParams: { search_id: this.searchId, city_code: this.cityCode } }
        );
      } else {
        urlTree = this.router.createUrlTree([`/product/${productSlug}`]);
      }
  
      this.baseUrl = this.router.serializeUrl(urlTree);
  
      if (this.locationStrategy instanceof HashLocationStrategy) {
        const baseHref = this.locationStrategy.getBaseHref();
        this.baseUrl = `${baseHref}#${this.baseUrl}`;
      }
  
      this.hostUrl = window.location.origin; // Ensure this runs only in browser
    }
  
    return `${this.hostUrl || ''}${this.baseUrl}`;
  }

  // openLink(productSlug: string) {
  //   if (isPlatformBrowser(this.platformId)) {
  //     if(this.isOndc){
  //       // let data ={product_id : productSlug, search_id:this.searchId}
  //       // this.router.navigate(['/ondc-product/'], {
  //       //   queryParams: data,
  //       // });
  //       let queryParams = new URLSearchParams({
  //         product_id: productSlug,
  //         search_id: this.searchId
  //       }).toString();
  
  //       return `/ondc-product/?${queryParams}`;
        
  //     } else{
  //       let urlTree: UrlTree = this.router.createUrlTree([
  //         `/product/${productSlug}`,
  //       ]);
  //       this.baseUrl = this.router.serializeUrl(urlTree);
  
  //       if (this.locationStrategy instanceof HashLocationStrategy) {
  //         const baseHref = this.locationStrategy.getBaseHref();
  //         this.baseUrl = `${baseHref}#${this.baseUrl}`;
  //       }
  
  //       this.hostUrl = window.location.origin;
  //     }
  //   }
  //   return `${this.hostUrl}${this.baseUrl}`;
  // }

  updateMetaTags(title: string, description: string): void {
    if (isPlatformBrowser(this.platformId)) {
      this.titleService.setTitle('tripXOXO - Activities, tours and transfers');
      this.meta.removeTag('property="og:title"');
      this.meta.removeTag('property="og:description"');

      this.meta.removeTag('name="title"');
      this.meta.removeTag('name="description"');

      // Add new Open Graph title, description, and image tags
      this.meta.addTag({ property: 'og:title', content: title });
      this.meta.addTag({ property: 'og:description', content: description });

      this.meta.addTag({ name: 'title', content: title });
      this.meta.addTag({ name: 'description', content: description });
    }
  }
}
